import {EnumObject} from "./enum-object";

export class CornerType extends EnumObject{
	public static readonly smallCorner = new CornerType('small-corner');

	public static readonly tallCorner = new CornerType('tall-corner');

	private constructor(code: string) {
		super(code);
	}
}
